// @flow
import React from 'react';

import { CHECKBOX_INPUT_TYPE } from '../../../formik-utils/consts';

// Confirmation Modal Config for editing SG Credits
export const CNBC_EDIT_CONFIRMATION_MODAL_CONFIG = {
  header: 'Change in System-Generated Credit and Bursts',
  body: (
    <>
      Once a system-generated credits and bursts configuration is manually edited, automatic SG
      (System Generated) numbers will no longer apply to the{' '}
      <strong style={{ color: '#DC2728' }}>ENTIRE ESTIMATE.</strong> This change cannot be undone on
      the estimate. If you wish to restore system-generated for this line item you will have to
      create a copy of the estimate and use the copy for future changes.
    </>
  ),
  okText: 'Yes, I want to proceed',
  cancelText: 'No, take me back!',
};

export const SG_CNBC_ID_PREFIX = 'SG-CNBC-';
export const CNBC_IS_ADMIN_BACKEND_NAME = 'is_admin_edited';

// Legend text explaining SG Credits
export const SG_CNBC_LEGEND_TEXT =
  'Note: SG , Ad, NA mean rows automatically added by the System Generated/Admin/Non-admin user respectively....';
export const SG_CNBC_NOTE_TEXT =
  'Note: Credits can be added up to 15% of ACV. Contact DSM for exceptions.';
export const SG_CNBC_RENEWAL_NOTE_TEXT =
  'Note: Credits can be added up to 15% of Net New commit for the deal duration. Contact DSM for exceptions.';

export const APPLY_SYSTEM_GENERATED_CNBC_BACKEND_NAME = 'sg_cnbc_enabled';
export const APPLY_SYSTEM_GENERATED_CNBC_DISPLAY_NAME = 'Apply System Generated Credits and Bursts';
export const APPLY_SYSTEM_GENERATED_CNBC_CONFIG = {
  displayName: APPLY_SYSTEM_GENERATED_CNBC_DISPLAY_NAME,
  backendFieldName: APPLY_SYSTEM_GENERATED_CNBC_BACKEND_NAME,
  inputType: CHECKBOX_INPUT_TYPE,
};
